<!-- ShowStatusInfo.vue -->
<template>
  <v-snackbar
    v-model="getSnackbarData.visible"
    :timeout="getSnackbarData.timeout"
    :color="getSnackbarData.color"
    :multi-line="getSnackbarData.multiline === true"
    bottom
    class="snackbar_wrapper"
    shaped
  >
    <v-card-text>{{ getSnackbarData.text }}</v-card-text>
    <template v-slot:action="{attrs}">
      <v-btn small icon v-bind="attrs" @click="closeSnackBar">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
  name: "ShowStatusInfo",
  computed: {
    ...mapGetters(["snackbar"]),
    getSnackbarData() {
      return this.snackbar;
    },
  },
  methods: {
    ...mapActions(["closeSnackBar"]),
  },
};
</script>

<style scoped>
.snackbar_wrapper {
  opacity: 100%;
}
</style>
